// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
	var $header = $('.l-header');
	$(window).scroll(function() {
		if ($(window).scrollTop() > 50) {
			$header.addClass('scrolling');
		} else {
			$header.removeClass('scrolling');
		}
	});
});